export const WhatsappButton = ({ number, message }) => {
  const normalizeSriLankaNumber = (input) => {
    if (!input) return "";

    // remove everything except numbers
    let num = input.replace(/\D/g, "");

    // if starts with 0 (077xxxxxxx) → 94xxxxxxxxx
    if (num.startsWith("0")) {
      num = "94" + num.substring(1);
    }

    // if already starts with 94, keep it
    if (num.startsWith("94")) {
      return num;
    }

    // fallback (last 9 digits)
    return "94" + num.slice(-9);
  };

  const handleClick = () => {
    if (typeof window === "undefined") return;

    const cleanNumber = normalizeSriLankaNumber(number);
    const text = encodeURIComponent(message || "");

    if (!cleanNumber) {
      alert("Invalid WhatsApp number");
      return;
    }

    const url = `https://wa.me/${cleanNumber}?text=${text}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <a
      type="button"
      onClick={handleClick}
      className="flex items-center border p-4 justify-center rounded-4 shadow-sm hover:shadow-md cursor-pointer hover:shadow-[#085585]/50 duration-300 transition-all"
    >
      <img src="/images/whatsapp.png" alt="WhatsApp" className="w-4 h-4 mr-2" />
      <p>WhatsApp</p>
    </a>
  );
};
